module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Wallet#2-9f8d68c5137fd740325ed7d5a554e4a9.svg";